import { ReactComponent as DownloadIcon } from 'assets/icons/graydownloadIcon.svg';
import { ReactComponent as EditIcon } from 'assets/icons/editIcon.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/menudots.svg';
import { ReactComponent as EyeIcon } from 'assets/icons/eyeIcon.svg';
import { Popover, Tooltip } from '@mantine/core';
import { useState } from 'react';
import dayjs from 'dayjs';
import AddNewStroryModal from './addnewstrorymodal';
// import AddNewStroryEmployeeModal from './addnewBlogemployee';
import DeleteStoryModal from './deletestoryModal';
import ViewStoryModal from './viewStoryModal';

import UnpublishBlog from './unpublishBlog';

const AdminBlogList = ({ blogData, name }) => {
  // const [publishPopover, setPublishPopover] = useState(false);
  const [menuPopover, setMenuPopover] = useState(false);
  const [newStoryModal, setNewStoryModal] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [unpublishModal, setUnpublishModal] = useState(false);

  const [publishData, setPublishData] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const [BlogId, setBlogId] = useState(null);

  const extractContent = (s) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };
  return (
    <>
      <div className='flex items-center justify-evenly gap-8 my-3 w-full'>
        <img src={blogData?.thumbnail} alt='Thumbnail' className='h-16 w-24' />
        <div className=''>
          {blogData?.title.length > 30 ? (
            <Tooltip
              label={blogData?.title}
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
              position='top-start'
            >
              <h1 className='text-normal font-semibold truncate w-80'>
                {blogData?.title}
              </h1>
            </Tooltip>
          ) : (
            <h1 className='text-normal font-semibold  w-80'>
              {blogData?.title}
            </h1>
          )}
          <p className='text-[#898888] truncate w-96'>
            {`${extractContent(blogData?.content).substring(0, 80)}........`}
          </p>
          <div className='flex item-center justify-start gap-8 '>
            <p className='text-primary'>
              {dayjs(blogData?.created_date).format('hh:mm A, DD MMM YY')}
            </p>
            <p className='text-[#B6B6B6]'>{blogData?.minutes} min read</p>
            <DownloadIcon className='mt-1' />
          </div>
        </div>
        {blogData?.topic.length > 0 ? (
          <Tooltip
            label='Topic'
            classNames={{
              body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
            }}
            radius='md'
          >
            <h1 className='text-[#FB0C51] bg-[#FFEBE5] p-2 truncate w-40 text-center px-4 font-semibold rounded-full'>
              {blogData?.topic}
            </h1>
          </Tooltip>
        ) : (
          <h1 className='text-[#FB0C51] bg-[#FFEBE5] p-2 truncate w-40 text-center px-4 font-semibold rounded-full'>
            {blogData?.topic}
          </h1>
        )}

        <div className='flex items-center justify-center gap-3'>
          <EyeIcon
            className='cursor-pointer'
            onClick={() => {
              setIsViewModal(true);
              setBlogId(blogData?.id);
            }}
          />
          <EditIcon
            className='cursor-pointer'
            onClick={() => {
              setNewStoryModal(true);
              setBlogId(blogData?.id);
            }}
          />
        </div>
        {/* <Popover
          opened={publishPopover}
          onClose={() => setPublishPopover(false)}
          target={ */}

        <h1
          className={
            blogData?.is_published
              ? 'font-medium text-[#28B446] text-normal w-40 '
              : 'font-medium text-[#FFCC4D] text-normal w-40  '
          }
        >
          {blogData?.is_published ? 'Published' : 'Under review'}
          {/* Under review */}
        </h1>

        {/* }
          width={150}
          position='bottom' */}
        {/* >
          <p className='text-[#8E8E8E] my-2 cursor-pointer'>Update</p>
          <hr className='text-[#8E8E8E] opacity-30' />
          <p className='text-[#8E8E8E] my-2 cursor-pointer'>Request delete</p>
        </Popover> */}
        {!blogData?.is_published ? (
          <Popover
            opened={menuPopover}
            onClose={() => setMenuPopover(false)}
            target={
              <MenuIcon
                className='h-5 w-5 cursor-pointer'
                onClick={() => setMenuPopover((o) => !o)}
              />
            }
            width={150}
            position='bottom'
          >
            <>
              <p
                className='text-[#8E8E8E] my-2 cursor-pointer'
                //   onClick={() =>
                //     useUpdateemployeeblogMutation.mutate({
                //       id: blogData?.id,
                //       is_deleted: 'False',
                //       is_draft: 'True',
                //     })
                //   }
                onClick={() => {
                  setNewStoryModal(true);
                  setBlogId(blogData?.id);
                }}
              >
                Edit
              </p>
              <hr className='text-[#8E8E8E] opacity-30' />
              <p
                className='text-[#8E8E8E] my-2 cursor-pointer'
                //   onClick={() =>
                //     deleteBlog.mutate({
                //       id: blogData?.id,
                //     })
                //   }
                onClick={() => {
                  setMenuPopover(false);
                  setDeleteModalOpen(true);
                }}
              >
                Delete
              </p>
            </>
          </Popover>
        ) : (
          <Popover
            opened={popoverOpen}
            onClose={() => setPopoverOpen(false)}
            target={
              <MenuIcon
                className='h-5 w-5 cursor-pointer'
                onClick={() => setPopoverOpen(!popoverOpen)}
              />
            }
            // width={220}
            width={150}
            position='bottom'
          >
            <p
              className='cursor-pointer  text-[#8E8E8E]'
              onClick={() => {
                setUnpublishModal(true);
                setPopoverOpen(false);
                setBlogId(blogData?.id);
              }}
            >
              Unpublish
            </p>
            {
              // <hr className='text-[#8E8E8E] opacity-50' />
              // <p
              //   className='cursor-pointer py-2 text-[#8E8E8E]'
              //   onClick={() => {
              //     setPublishModal(true);
              //     setPublishData(blogData?.published_on);
              //     setBlogId(blogData?.id);
              //     setPopoverOpen(false);
              //   }}
              // >
              //   Publish to a new domain
              // </p>
            }
          </Popover>
        )}
        <DeleteStoryModal
          deleteModal={isDeleteModalOpen}
          setDeleteModal={setDeleteModalOpen}
          blogdata={blogData}
        />
      </div>
      <AddNewStroryModal
        newStoryModal={newStoryModal}
        setNewStoryModal={setNewStoryModal}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />

      <UnpublishBlog
        setUnpublishModal={setUnpublishModal}
        unpublishModal={unpublishModal}
        publishData={publishData}
        setPublishData={setPublishData}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />
      <ViewStoryModal
        isViewModal={isViewModal}
        BlogId={BlogId}
        setIsViewModal={setIsViewModal}
        newStoryModal={newStoryModal}
        blogdata={blogData}
      />
    </>
  );
};

export default AdminBlogList;
